import React from 'react';

import MDSnackbar from "../../materialDashboard/components/MDSnackbar";

export const SnackbarError = props => {
    const {title = "Error", message = "An unhandled exception occurred while rendering the page"} = props;
    const [open, setOpen] = React.useState(true);

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };

    return <MDSnackbar
        color="error"
        icon="warning"
        title={title}
        dateTime=""
        content={message}
        open={open}
        onClose={handleClose}
        close={handleClose}
        bgWhite
    />;
};


export default SnackbarError;